import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { round6 as round } from 'utilities/math';
import { isRequiredNumber, isRequiredNumberGreaterThan, isRequiredIntegerGreaterThan } from 'utilities/validators.js';

import Input from 'components/Input';
import Dropdown from '../Dropdown';

const isPositiveNumber = isRequiredNumberGreaterThan(0);
const isMoreThanOneInteger = isRequiredIntegerGreaterThan(1);

class SettingsFormComponent extends React.PureComponent {
  formatFn = value => value || value === 0 ? round(value) : '';

  renderVariablesDropDown = () => {
    const { numericalOptionsDataSet, onGenerateMeanDataSet } = this.props;

    if (!numericalOptionsDataSet || !numericalOptionsDataSet.length) {
      return null;
    }

    return (
      <Dropdown
        isClearable
        optionsList={numericalOptionsDataSet}
        label="Sample Variable"
        name="numericalRowDataSet"
        placeholder="Select a Variable"
        onChange={onGenerateMeanDataSet}
        id="chosen-row-dataSet-dropdown"
      />
    );
  }

  render () {
    const { onHandleInputs } = this.props;
    return (
      <>
        {this.renderVariablesDropDown()}
        <div className="flex space-between mb-15">
          <Field
            type="number"
            id="sampleMean"
            component={Input}
            name="sampleMean"
            label="Sample Mean"
            pattern="\d+"
            format={this.formatFn}
            onChange={onHandleInputs}
            validate={isRequiredNumber}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />

          <Field
            type="number"
            id="standardDeviation"
            component={Input}
            name="standardDeviation"
            label="Sample St. Dev."
            pattern="\d+"
            min={1}
            format={this.formatFn}
            onChange={onHandleInputs}
            validate={isPositiveNumber}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />

          <Field
            type="number"
            id="sampleSize"
            component={Input}
            name="sampleSize"
            label="Sample Size"
            pattern="\d+"
            min={2}
            format={this.formatFn}
            onChange={onHandleInputs}
            validate={isMoreThanOneInteger}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />
        </div>
      </>
    );
  }
}

SettingsFormComponent.propTypes = {
  onHandleInputs: PropTypes.func.isRequired,
  onGenerateMeanDataSet: PropTypes.func.isRequired,
  numericalOptionsDataSet: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string
  }))
};

export default SettingsFormComponent;
